import type { Sticker } from '../types';

export const home: Sticker[] = [
  {
    id: 19001,
    url: 'https://stickers.nauczniaczek.pl/colections/14353631-home/png/001-home.png',
    name: 'Dom',
    category: 'home',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 19002,
    url: 'https://stickers.nauczniaczek.pl/colections/14353631-home/png/002-coffee time.png',
    name: 'Czas na Kawę',
    category: 'home',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 19003,
    url: 'https://stickers.nauczniaczek.pl/colections/14353631-home/png/003-laundry.png',
    name: 'Pranie',
    category: 'home',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 19004,
    url: 'https://stickers.nauczniaczek.pl/colections/14353631-home/png/004-watering plants.png',
    name: 'Podlewanie Roślin',
    category: 'home',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 19005,
    url: 'https://stickers.nauczniaczek.pl/colections/14353631-home/png/005-decoration.png',
    name: 'Dekoracja',
    category: 'home',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 19006,
    url: 'https://stickers.nauczniaczek.pl/colections/14353631-home/png/006-relax.png',
    name: 'Relaks',
    category: 'home',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 19007,
    url: 'https://stickers.nauczniaczek.pl/colections/14353631-home/png/007-radio.png',
    name: 'Radio',
    category: 'home',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 19008,
    url: 'https://stickers.nauczniaczek.pl/colections/14353631-home/png/008-cooking.png',
    name: 'Gotowanie',
    category: 'home',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 19009,
    url: 'https://stickers.nauczniaczek.pl/colections/14353631-home/png/009-home.png',
    name: 'Przytulny Dom',
    category: 'home',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 19010,
    url: 'https://stickers.nauczniaczek.pl/colections/14353631-home/png/010-coffee.png',
    name: 'Kawa',
    category: 'home',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 19011,
    url: 'https://stickers.nauczniaczek.pl/colections/14353631-home/png/011-music.png',
    name: 'Muzyka',
    category: 'home',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 19012,
    url: 'https://stickers.nauczniaczek.pl/colections/14353631-home/png/012-handcraft.png',
    name: 'Rękodzieło',
    category: 'home',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 19013,
    url: 'https://stickers.nauczniaczek.pl/colections/14353631-home/png/013-home.png',
    name: 'Domowe Zacisze',
    category: 'home',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 19014,
    url: 'https://stickers.nauczniaczek.pl/colections/14353631-home/png/014-petting.png',
    name: 'Głaskanie Zwierzaka',
    category: 'home',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 19015,
    url: 'https://stickers.nauczniaczek.pl/colections/14353631-home/png/015-housekeeping.png',
    name: 'Sprzątanie',
    category: 'home',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 19016,
    url: 'https://stickers.nauczniaczek.pl/colections/14353631-home/png/016-mail.png',
    name: 'Poczta',
    category: 'home',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 19017,
    url: 'https://stickers.nauczniaczek.pl/colections/14353631-home/png/017-laundry.png',
    name: 'Pranie w Koszu',
    category: 'home',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 19018,
    url: 'https://stickers.nauczniaczek.pl/colections/14353631-home/png/018-home.png',
    name: 'Domowe Ognisko',
    category: 'home',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 19019,
    url: 'https://stickers.nauczniaczek.pl/colections/14353631-home/png/019-bath.png',
    name: 'Kąpiel',
    category: 'home',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 19020,
    url: 'https://stickers.nauczniaczek.pl/colections/14353631-home/png/020-decoration.png',
    name: 'Ozdoba',
    category: 'home',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  }
];